import { map } from 'lodash'
import { trans } from 'utils/helpers/translation'

export const getProductUnits = ({ productUnits }) => map(productUnits, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getDealPerceptions = ({ deal }) => map(deal.perceptions, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getDealStatus = ({ deal }) => map(deal.status, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getDealFields = ({ deal }) => map(deal.fields, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getIncomingStatus = ({ incoming }) => map(incoming.status, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getTaskStatus = ({ task }) => map(task.status, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getQuotationStatus = ({ quotation }) => map(quotation.status, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getEmailStatus = ({ emails }) => map(emails.status, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getEmailSenders = ({ emails }) => map(emails.senders, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getLanguages = ({ languages }) => map(languages, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getGender = ({ gender }) => map(gender, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getSalesReportTypes = ({ reports }) => {
    if (typeof reports.sales === 'undefined')
        return []
    return map(reports.sales.types, (obj) => ({id: obj.id, name: trans(obj.name)}))
}

export const getRoles = ({ roles }) => map(roles, (obj) => {
    return { id: obj.id, name: trans(obj.name) }
})

export const getIsMainMenuOpen = ({ isMainMenuOpen }) => isMainMenuOpen

export const getIntegrationDealApproaches = ({ integrations }) => map(integrations.approaches.filter((item) => item.name !== 'sequential_incoming'), (obj) => {
    return { id: obj.id, name: trans('_integrations.approaches.' + obj.name) + ' - ' + trans('_integrations.approaches.' + obj.name + '_helper') }
})

export const getIntegrationIncomingApproaches = ({ integrations }) => map(integrations.approaches.filter((item) => item.name !== 'sequential_deal'), (obj) => {
    return { id: obj.id, name: trans('_integrations.approaches.' + obj.name) + ' - ' + trans('_integrations.approaches.' + obj.name + '_helper') }
})



// WEBPACK FOOTER //
// ./src/store/global/getters.js